import { isLocalUrl } from '../localjs';

export default function (buttonsContainer, removeButtons) {
  const widgetName = 'noEventsButtons';
  const widgetOpts = noEventsButtonsOpts;
  const $widget = $(`#${widgetName}`);
  const $btnsContainer = $(`.${buttonsContainer}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 2,
    maxItemsVisible: 2,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!removeButtons) {
        $widget.addClass('no-events-buttons');
        $btnsContainer.append(`
        <div class="no-events-container">
          <h2 class="no-events-title">plan your event</h2>
        </div>
        `);

        if (!hasData) {
          $widget.remove();
          $('.no-events-container').addClass('no-btns');
          $('.no-events-container .no-events-title').text('New events soon!!!');
        } else {
          $('.no-events-container').append('<div class="no-events-buttons"></div>');
          createCustomSeo(data.items);
          $widget.remove();
        }
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');

    $seo.each(function (x) {
      const { Title, URL } = widgetData[x];
      let urlAttribute = isLocalUrl(URL) ? '' : 'target="_blank"';

      let newItem = `<a href=${URL} ${urlAttribute} class="secondary-button">${Title}</a>`;
      $('.no-events-buttons').append(newItem);
    });
  }
}
